import React from 'react';
import UserStats from './UserStats';

const Stats = ({ books, userData, theme }) => {
  return (
    <main>
      <UserStats books={books} userData={userData} theme={theme} />
    </main>
  );
};

export default Stats;
